<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <div class="hs-screen-row">
                <Input v-model="params.configKey" placeholder="名称" clearable style="width: 200px"/>
            </div>

            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="findAllConfig">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>平台配置</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findAllConfig">
                                <Icon type="md-refresh" size="15"/>
                            </Button>

                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <!--表格数据-->
            <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">
                <template slot-scope="{ row, index }" slot="configValue">
                    <span v-if="row.configValue">{{row.configValue}}</span>
                    <span v-else>-</span>
                </template>

                <template slot-scope="{ row, index }" slot="isTenant">
                  <Tag color="volcano" v-if="row.isTenant === 0" size="default">否</Tag>
                  <Tag color="green" v-if="row.isTenant === 1" size="default">是</Tag>
                </template>

                <template slot-scope="{ row }" slot="action">
                    <Button type="success" size="small" style="margin-right: 5px" @click="showConfigOpe(1, row)">查看
                    </Button>
                    <Button type="primary" size="small" style="margin-right: 5px" @click="showConfigOpe(3, row)">编辑
                    </Button>
                </template>
            </Table>
        </Card>

        <!--平台配置操作-->
        <config-ope ref="configOpe" @changeData="findAllConfig"></config-ope>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    import configOpe from './components/config-ope';

    export default {
        name: "config",
        data() {
            return {
                total: 0,
                isTableLoading: false,
                dateInit: '',
                params: {
                    page: 1,
                    rows: 10,
                    configKey: '',
                    startTime: '',
                    endTime: ''
                },
                // 表格列
                columns: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '类型',
                        minWidth: 120,
                        key: 'configType'
                    },
                    {
                        title: '名称',
                        minWidth: 120,
                        key: 'configKey'
                    },
                    {
                        title: '值',
                        minWidth: 120,
                        slot: 'configValue'
                    },
                    {
                      title: '是否加盟商设置',
                      minWidth: 180,
                      slot: 'isTenant'
                    },
                    {
                        title: '备注',
                        minWidth: 180,
                        key: 'remark'
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width: 150
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180,
                        align: 'center'
                    }
                ],
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '系统管理', url: '', icon: '', size: 0},
                    {name: '平台配置', url: '', icon: '', size: 0}
                ]
            }
        },
        created() {
            // 平台配置-列表查询
            this.findAllConfig();
        },
        methods: {
            // 平台配置-列表查询
            findAllConfig() {
                this.isTableLoading = true;
                this.axios.post('/config/findAllConfig', this.params).then(res => {
                    console.log(res);
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '配置列表查询接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 显示操作模态框
            showConfigOpe(type, row) {
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                this.$refs.configOpe.show(type, row);
            },
            // 重置筛选条件
            resetScreen() {
                this.params.configKey = '';
                this.params.startTime = '';
                this.params.endTime = '';
                this.dateInit = '';
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.startTime = e[0];
                this.params.endTime = e[1];
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findAllConfig();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findAllConfig();
            }
        },
        components: {
            hsBreadcrumb,
            configOpe
        }
    }
</script>

<style scoped>

</style>